import styled from "styled-components";

export const Header = styled.div`
  font-size: 12px;
  color: #6b778c;
  font-weight: 600;
  line-height: 1.33333333;
`;
Header.displayName = "Header";
